module.exports = __webpack_public_path__ + "img/treatment-icon.af1f2bc7.svg";